export const ClearCache = () => {
  caches.keys().then(names => {
    names.forEach(name => {
      caches.delete(name);
    });
  });
};



// WEBPACK FOOTER //
// ./src/components/utils/clear-cache/ClearCache.js